/* NELY SPORTS — theme behaviour */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------- mobile nav -- */
  function initNav() {
    var hdr = document.querySelector('[data-header]');
    if (!hdr) return;
    var btn = hdr.querySelector('[data-nav-toggle]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var open = hdr.getAttribute('data-open') === 'true';
      hdr.setAttribute('data-open', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      document.body.style.overflow = open ? '' : 'hidden';
    });

    // close on nav click + on escape
    hdr.querySelectorAll('.nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        hdr.setAttribute('data-open', 'false');
        btn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && hdr.getAttribute('data-open') === 'true') {
        hdr.setAttribute('data-open', 'false');
        btn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        btn.focus();
      }
    });
  }

  /* ---------------------------------------------------- scroll reveal -- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------- colour lab -- */
  var STORE_KEY = 'nely:signal';

  function readableInk(hex) {
    var c = hex.replace('#', '');
    if (c.length === 3) c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2];
    var r = parseInt(c.slice(0, 2), 16) / 255;
    var g = parseInt(c.slice(2, 4), 16) / 255;
    var b = parseInt(c.slice(4, 6), 16) / 255;
    var f = function (v) { return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    var L = 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
    return L > 0.45 ? '#0B0B0C' : '#FFFFFF';
  }

  function applySignal(hex) {
    document.documentElement.style.setProperty('--signal', hex);
    document.documentElement.style.setProperty('--signal-ink', readableInk(hex));
  }

  function initLab() {
    // restore a previously chosen colour across pages
    try {
      var saved = window.localStorage.getItem(STORE_KEY);
      if (saved && /^#[0-9a-f]{6}$/i.test(saved)) applySignal(saved);
    } catch (e) { /* storage blocked — non-critical */ }

    var lab = document.querySelector('[data-lab]');
    if (!lab) return;

    var chips = lab.querySelectorAll('[data-chip]');
    var swatch = lab.querySelector('[data-lab-swatch]');
    var nameOut = lab.querySelector('[data-lab-name]');
    var hexOut = lab.querySelector('[data-lab-hex]');
    var refOut = lab.querySelector('[data-lab-ref]');

    function select(btn, persist) {
      var hex = btn.getAttribute('data-chip');
      var name = btn.getAttribute('data-name') || '';
      var ref = btn.getAttribute('data-ref') || '';

      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');

      applySignal(hex);
      if (swatch) swatch.style.background = hex;
      if (nameOut) nameOut.textContent = name;
      if (hexOut) hexOut.textContent = hex.toUpperCase();
      if (refOut) refOut.textContent = ref;

      if (persist) {
        try { window.localStorage.setItem(STORE_KEY, hex); } catch (e) {}
      }
    }

    chips.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn, true); });
    });

    // reflect whichever chip matches the active colour, else the first
    var current = getComputedStyle(document.documentElement)
      .getPropertyValue('--signal').trim().toLowerCase();
    var match = null;
    chips.forEach(function (c) {
      if ((c.getAttribute('data-chip') || '').toLowerCase() === current) match = c;
    });
    if (match) select(match, false);
    else if (chips.length) select(chips[0], false);
  }

  /* -------------------------------------------------------------- faq -- */
  function initFaq() {
    document.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-faq-q]');
      var panel = item.querySelector('[data-faq-a]');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        // close siblings for a single-open accordion
        var group = item.parentElement;
        if (group) {
          group.querySelectorAll('[data-faq-item][data-open="true"]').forEach(function (other) {
            if (other === item) return;
            other.setAttribute('data-open', 'false');
            var ob = other.querySelector('[data-faq-q]');
            var op = other.querySelector('[data-faq-a]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
            if (op) op.style.height = '0px';
          });
        }
        item.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.style.height = open ? '0px' : panel.scrollHeight + 'px';
      });
    });

    // keep an open panel correctly sized after a resize
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        document.querySelectorAll('[data-faq-item][data-open="true"]').forEach(function (item) {
          var panel = item.querySelector('[data-faq-a]');
          if (panel) panel.style.height = panel.scrollHeight + 'px';
        });
      }, 150);
    });
  }

  /* ----------------------------------------------------- sticky header -- */
  function initStickyHeader() {
    var hdr = document.querySelector('[data-header]');
    if (!hdr) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (hdr.getAttribute('data-open') === 'true') return;
      // hide on scroll down past the fold, show on scroll up
      if (y > 240 && y > last) hdr.style.transform = 'translateY(-100%)';
      else hdr.style.transform = '';
      last = y;
    }, { passive: true });
  }

  /* ------------------------------------------------------- form helper -- */
  function initForm() {
    document.querySelectorAll('#enquiry-form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[type="submit"]');
        if (btn) {
          btn.setAttribute('disabled', 'disabled');
          var label = btn.querySelector('span');
          if (label) label.textContent = 'Sending…';
        }
      });
    });

    // if Shopify returned a result, bring it into view
    var msg = document.querySelector('[data-form-status]');
    if (msg) {
      msg.setAttribute('tabindex', '-1');
      msg.focus({ preventScroll: true });
      msg.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
  }

  function boot() {
    initNav();
    initStickyHeader();
    initReveal();
    initLab();
    initFaq();
    initForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
